import { registerQuery } from 'data-fetching-client';
import * as ecosystemClient from '../clients/ecosystemClient';
import { ASSET_INSTALLABILITY_QUERY_FIELD_NAME } from '../constants/AssetInstallability';
export const GET_ASSET_INSTALLABILITY = registerQuery({
  fieldName: ASSET_INSTALLABILITY_QUERY_FIELD_NAME,
  args: ['offeringId'],
  fetcher: ({
    offeringId
  }) => {
    return ecosystemClient.getAssetInstallability(offeringId);
  }
});